export default __webpack_public_path__ + "images/ido-launchpad_3eafed.png";